/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Verify_Capability_FeedInputs */

const cs_portals_verify_capability_feed = /** @type {(inputs: Portals_Verify_Capability_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed`)
};

const en_portals_verify_capability_feed = /** @type {(inputs: Portals_Verify_Capability_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed`)
};

/**
* | output |
* | --- |
* | "Feed" |
*
* @param {Portals_Verify_Capability_FeedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify_capability_feed = /** @type {((inputs?: Portals_Verify_Capability_FeedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Verify_Capability_FeedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify_capability_feed(inputs)
	return cs_portals_verify_capability_feed(inputs)
});